<template>
  <div class="page-box">
    <div class="right">
      <div class="opt-btn">
        <div class="title">限报规则：指定的某类组别，选手限制报名的项目数</div>
        <el-button type="danger" size="mini" @click="addRules()">新增规则</el-button>
      </div>
      <div class="table-box" :style="{'--height':height}">
        <el-table :data="tableData" ref="unitRef" highlight-current-row :header-cell-style="{background:'#e4e4e4',border:'none',color:'#000000',fontWeight:'bolder',fontSize:'0.8rem',padding:'0.5rem'}" :cell-style="{padding:'0.3rem',fontSize:'0.8rem'}"
						current-row-key="id"  border
						style="width:100%;height: calc(100%);overflow-y: hidden;font-size: 0.8rem;">
            <el-table-column prop="ruleName" label="规则名称" max-width="550px">
						</el-table-column>
						<el-table-column prop="groupClassifyName" label="所属组别" width="200px">
						</el-table-column>
						<el-table-column prop="limitItemTimes" label="限报项数" align="center" width="80px">
						</el-table-column>
						<el-table-column prop="createDate" label="创建时间" align="center" width="180px">
						</el-table-column>
						<el-table-column prop="" label="操作" align="center" width="120px">
							<template slot-scope="{row}">
								<el-button type="text" @click="editItem(row)" size="mini">修改</el-button>
								<el-button type="text" @click="deleteItemType(row)" size="mini">删除</el-button>
							</template>
						</el-table-column>
            <el-table-column label="" width="auto">
						</el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10,20,30, 40, 80, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
        >
          :pager-count="5">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import AddGroupRule from "./add-group-rules.vue";
import { openDialog } from "../../../../../../../components/fn-dialog";
import { deleteLimitSignupRuleById, pageLimitSignupRules } from "../../../../../api/mymatchs/groupsetitem";
export default {
  name: "group-type",
  data() {
    return {
        totalNum:0,
        pageSize:30,
        currentPage:1,
        tableData:[],
        height:"100%"
    };
  },
  mounted() {
    setTimeout(() => {
      this.height = this.$refs.unitRef.$el.clientHeight + 'px';
      this.matchId = this.$route.query.matchId;
      this.getTableDataLocal();
    }, 100);
  },
  beforeDestroy() {},
  methods: {
    sizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.getTableDataLocal();
    },
    currentChange(val) {
      this.currentPage = val;
      this.getTableDataLocal();
    },
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    addRules(){
      openDialog(AddGroupRule, {
        title: "新增限报规则",
        width: "500px",
        height: "400px",
        params:{
          matchId: this.matchId
        },
        callback:()=>{
          this.currentPage = 1;
          this.getTableDataLocal()
        }
      })
    },
    editItem(row){
      openDialog(AddGroupRule, {
        title: "修改限报规则",
        width: "500px",
        height: "400px",
        params:{
          matchId: this.matchId,
          row
        },
        callback:()=>{
          this.currentPage = 1;
          this.getTableDataLocal()
        }
      })
    },
    deleteItemType(row){
      this.$confirm("确认删除该数据吗?", "提示").then(async (confirm) => {
        if(confirm==='confirm'){
          const res = await deleteLimitSignupRuleById({id:row.id});
          if(res && res.status == 200){
            this.$message.success("删除成功");
            this.getTableDataLocal();
          }else{
            res && res.msg && this.$message.error(res.msg);
          }
        }
      })
    },
    async getTableDataLocal(){
      const params = {
        currPage:this.currentPage,
        pageSize:this.pageSize,
        matchId:this.matchId
      }
      const res = await pageLimitSignupRules(params);
      if(res && res.status == 200){
        this.totalNum = res.data.total;
        this.tableData = res.data.list;
      }else{
        res && res.msg && this.$message.error(res.msg);
      }

    }
  },
};
</script>
<style lang="scss" scoped>
.page-box {
  width: calc(100%);
  height: calc(100%);
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  .left {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 60px 1fr 60px;
    .opt-btn {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0 15px;
      
    }
    .table-box{
      background-color: #fff;
      height: calc(var(--height));
      overflow: hidden;

      ::v-deep .el-table__body-wrapper {
        height: calc(100% - 37px);
        overflow-y: auto;
      }
    }
    .page{
        background-color: #fff;
        box-shadow: 0px -2px 8px #f2f2f2;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 15px;
    }
  }
  .right {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 60px 1fr 60px;
    .opt-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      .title{
        color:#7F7F7F;
        font-size: 14px;
      }
    }
    .table-box{
        background-color: #fff;
        height: calc(var(--height));
        overflow: hidden;

        ::v-deep .el-table__body-wrapper {
          height: calc(100% - 37px);
          overflow-y: auto;
        }
    }
    .page{
        background-color: #fff;
        box-shadow: 0px -2px 8px #f2f2f2;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 15px;

    }
  }
  ::v-deep .el-button--danger{
    background-color: #F32C6C;
  }
}
</style>
